import React from 'react';
import { useFormikContext, Field } from 'formik';
import dayjs from 'dayjs';

import {
  InputUI,
  SelectUI,
  DatePickerUI,
  FormErrorUI,
  AutoCompleteSelectUI,
  NumberFormatInputUI,
} from '../../Interface';
import { getJokerFieldType } from '../../../utils/helper';
import { JokerFieldTypes } from '../../../config/joker';

const JokerTab = ({ fields, disabled, issuedInvoiceJokerFieldsEditable = false }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const jokerFieldsDisabled = disabled && !issuedInvoiceJokerFieldsEditable;
  return fields.map((field, index) => {
    const f = field.jokerField;

    let fieldType = getJokerFieldType(f);
    //fieldtype alapján létrehozzuk a mezőket
    if (fieldType === JokerFieldTypes.SELECT) {
      return (
        <Field
          key={index}
          name={f.field}
          type={'select'}
          component={AutoCompleteSelectUI}
          fullWidth
          variant="standard"
          label={f.name}
          disabled={jokerFieldsDisabled}
          InputLabelProps={{ shrink: values[f.field] && values[f.field] !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
          dataset={f.valuesToForm}
          onChange={(_e, newVal) => {
            setFieldValue(f.field, newVal?.value ?? null);
          }}
          selectedValue={values[f.field] ?? null}
          selectedLabelValue={f.valuesToForm?.find((p) => p.value === values[f.field])?.label ?? ''}
        />
      );
    } else if (fieldType === JokerFieldTypes.DATE) {
      return (
        <Field
          key={index}
          name={f.field}
          component={DatePickerUI}
          fullWidth
          variant="standard"
          label={f.name}
          disabled={jokerFieldsDisabled}
          value={values[f.field] ? dayjs(values[f.field]) : null}
          onChange={(newDate) => {
            const value = newDate?.isValid() ? dayjs(newDate).startOf('day').add(12, 'hour').toISOString() : null;
            setFieldValue(f.field, value);
          }}
          InputLabelProps={{ shrink: values[f.field] && values[f.field] !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
        />
      );
    } else if (fieldType === JokerFieldTypes.NUMBER) {
      return (
        <Field
          name={f.field}
          as={InputUI}
          fullWidth
          variant="standard"
          label={f.name}
          disabled={jokerFieldsDisabled}
          InputProps={{
            inputComponent: NumberFormatInputUI,
          }}
          InputLabelProps={{ shrink: values[f.field] !== null && values[f.field]?.toString() !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
          //onChange={handleChange}
          //{...props}
        />
      );
    } else if (fieldType === JokerFieldTypes.TEXT) {
      return (
        <Field
          name={f.field}
          type="text"
          as={InputUI}
          fullWidth
          variant="standard"
          label={f.name}
          disabled={jokerFieldsDisabled}
          InputLabelProps={{ shrink: values[f.field] && values[f.field] !== '' }}
          helperText={<FormErrorUI message={errors[f.field]} />}
          //onChange={handleChange}
          //{...props}
        />
      );
    }
  });
};

export default JokerTab;
